import { render, staticRenderFns } from "./IndexEnabledStudents.vue?vue&type=template&id=7c77d812&"
import script from "./IndexEnabledStudents.vue?vue&type=script&lang=js&"
export * from "./IndexEnabledStudents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports